<template>
    <div class="buttom-bar">
        <div class="tab" @click="buttomHandle(0)" :class="{ active: activeIndex == 0 }">
            <img class="icon-img" onload="SVGInject(this)" round fit="cover" :src="icon1" />
            <p>我的待办</p>
        </div>
        <div class="tab" @click="buttomHandle(1)" :class="{ active: activeIndex == 1 }">
            <img class="icon-img" onload="SVGInject(this)" round fit="cover" :src="icon2" />
            <p>我的已办</p>
        </div>
        <div class="tab" @click="buttomHandle(2)" :class="{ active: activeIndex == 2 }">
            <img class="icon-img" onload="SVGInject(this)" round fit="cover" :src="icon3" />
            <p>我发起的</p>
        </div>
        <div class="tab" @click="buttomHandle(3)" :class="{ active: activeIndex == 3 }">
            <img class="icon-img" onload="SVGInject(this)" round fit="cover" :src="icon4" />
            <p>草稿箱</p>
        </div>
        <div class="tab" @click="buttomHandle(4)" :class="{ active: activeIndex == 4 }">
            <img class="icon-img" onload="SVGInject(this)" round fit="cover" :src="icon5" />
            <p>抄送我的</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ButtomBar",
        props: ["active", "rsv1"],
        data() {
            return {
                activeIndex: 0,
                rsv1Index: 0,
                icon1: require("@/assets/image/mineMore/todo.svg"),
                icon2: require("@/assets/image/mineMore/done.svg"),
                icon3: require("@/assets/image/mineMore/send.svg"),
                icon4: require("@/assets/image/mineMore/draft.svg"),
                icon5: require("@/assets/image/mineMore/copy.svg"),
            }
        },
        created() {
            this.activeIndex = this.active
            this.rsv1Index = this.rsv1
            this.rsv2 = this.$route.query.rsv2
            console.log('this.rsv2: ', this.rsv2);
            
        },
        methods: {
            buttomHandle(index) {
                if (this.rsv1Index == 1) {
                    this.activeIndex = index
                    this.$emit("buttomHandle", index, 1, this.rsv2)
                } else {
                    this.activeIndex = index
                    this.$emit("buttomHandle", index, 0, this.rsv2)
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .buttom-bar {
        display: flex;
        height: 55px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        .tab {
            display: flex;
            flex: 1;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            line-height: 1;
            cursor: pointer;
            font-size: 12px;
            img,
            svg {
                height: 20px;
            }
            &.active {
                color: var(--main-color);
                img,
                svg {
                    fill: var(--main-color);
                }
            }
        }
    }
</style>
